// @mui material components
import Card from "@mui/material/Card";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";

// Material Kit 2 PRO React examples
import NavbarHeader from "layouts/navbar-header/landing-pages/current/index.js";
import DefaultFooter from "components/Footers/DefaultFooter";

// About Us page sections
import Roadmap from "pages/LandingPages/Sections/Roadmap";
import Blockchains from "pages/LandingPages/Sections/Blockchains";
import Information from "pages/LandingPages/Sections/Information";
import Newsletter from "pages/LandingPages/Sections/Newsletter";

// Routes
import footerRoutes from "footer.routes";

function Main() {
    return (
        <>
            <NavbarHeader />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <Roadmap />
                <Blockchains />
                <Information />
                <Newsletter />
            </Card>
            <MKBox pt={6} px={1} mt={6}>
                <DefaultFooter footerContent={footerRoutes} />
            </MKBox>
        </>
    );
}

export default Main;
